// Clase puente entre la librería definitiva de overlay y la cutrada actual
// que tenemos. Para no detenerme a rehacer el overlay, de momento creo este
// puente que lo hará es utilizar el overlay antiguo. Usa jquery
/* global $ */
class Overlay {
  constructor(element, options) {
    this.options = { ...options };
    this.$element = $(element);
  }

  show() {
    let classesOverlay = this.options.classesOverlay || '';
    let classesLoading = this.options.classesLoading || '';
    const ocultarOverlay = this.options.ocultarOverlay === true;

    if (!this.$element.length) {
      return this;
    }

    // Ya hay un overlay activo, no ponemos otro
    if (this.$element.data('overlay-component')) {
      return this.$element.data('overlay-component');
    }

    const forced = (this.options.forced === true) ? ' ibox-overlay-forced' : '';
    classesOverlay += forced;
    classesLoading += forced;

    if (this.options.position === 'centerScreen') {
      classesLoading += ' loading-center-screen';
    } else if (this.options.position === 'top') {
      classesLoading += ' loading-top';
    }
    this.originalPosition = this.$element.css('position');
    this.$element.css('position', 'relative');

    const overlayEl = `<div class="ibox-overlay ${classesOverlay}"></div>`;
    const loadingEl = `<div class="ibox-loading ${classesLoading}">
      <i class="fa fa-fw fa-circle-notch fa-spin fa-3x"></i>
    </div>`;

    if (ocultarOverlay) {
      this.$element.prepend(loadingEl);
    } else {
      this.$element.prepend(overlayEl + loadingEl);
    }
    this.$element.data('overlay-component', this);
    return this;
  }

  hide() {
    this.$element.find('.ibox-overlay, .ibox-loading').remove();
    this.$element.removeData('overlay-component');
    this.$element.css('position', this.originalPosition);
    return this;
  }
}

export default Overlay;
